import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MsalService} from "@azure/msal-angular";
import {Router} from "@angular/router";

import Swal from "sweetalert2";

import {AuthService, MessageService, RegistrationService} from "@services";
import {AppBaseComponent} from "@utils";
import {catchError, switchMap, throwError} from "rxjs";

@Component({
  selector: 'app-legal-person-profile',
  templateUrl: './legal-person-profile.component.html',
  styleUrls: ['./legal-person-profile.component.scss']
})
export class LegalPersonProfileComponent extends AppBaseComponent implements OnInit {

  legalForm: FormGroup

  sending: boolean = false;

  public tipoIdentificacionn: any[] = [];
  public Nit: any = {};

  constructor(public fb: FormBuilder,
              public registrationService: RegistrationService,
              private popupAlert: MessageService,
              private authService: AuthService,
              private msalAuthService: MsalService,
              private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.legalForm = this.fb.group({
      nombreRazonSocial: ['', [Validators.required]],
      tipoDocumentoRepresentanteLegal: ['', [Validators.required]],
      numeroDocumentoRepresentanteLegal: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      primerNombre: ['', [Validators.required]],
      segundoNombre: [''],
      primerApellido: ['', [Validators.required]],
      segundoApellido: [''],
      tipoDocumento: ['', [Validators.required]],
      numeroIdentificacion: ['', [Validators.required]],
      telefonoFijo: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern("^[0-9]*$")]],
      telefonoCelular: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern("^[0-9]*$")]],
      email: ['', [Validators.required, Validators.email]],
      confirmarEmail: ['', [Validators.required, Validators.email]],
      checkBoxDatosPersonales: ['', [Validators.required, Validators.requiredTrue]]
    })

    this.registrationService.getTipoIdentificacion().subscribe(resp => {
      this.tipoIdentificacionn = resp.data;
      this.Nit = this.tipoIdentificacionn.find(depa => depa.idTipoIdentificacion == 5);

      this.tipoIdentificacionn = this.tipoIdentificacionn.filter(tipo => tipo.idTipoIdentificacion != 5)
      if (this.Nit) {
        this.legalForm.get('tipoDocumentoRepresentanteLegal').setValue(this.Nit.idTipoIdentificacion);
      }
    });
  }

  cuerpoEmail(fullName, numeroIdentificacion) {
    let bodyEmail = "Respetado(a) Ciudadano(a)," + fullName + "<br>" +
      "<br>" +
      "¡Gracias por registrarse! <br>" +
      "<br>" +
      "Puede acceder a la plataforma a través del siguiente enlace <a href='https://lemon-smoke-06942be0f-dev.eastus2.2.azurestaticapps.net'> Tramites</a> <br>" +
      "<br>" +
      "Ante cualquier inquietud puede consultar la información dispuesta en el portal de la Ventanilla Única de Trámites y Servicios o a través del correo contactenos@saludcapital.gov.co <br>" +
      "<br>" +
      "Cordialmente,<br>" +
      "<br>" +
      "SECRETARIA DISTRITAL DE SALUD<br>" +
      "<a href='https://lemon-smoke-06942be0f-dev.eastus2.2.azurestaticapps.net'> Tramites</a> <br>" +
      "KR 32 No. 12 - 81<br>" +
      "Teléfono (601)3649090<br>" +
      "<img src='https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.colnodo.apc.org%2Fes%2Forganizaciones-aliadas%2Fsecretaria-distrital-de-salud&psig=AOvVaw3nV8X82K0RbU_RliXnBHdI&ust=1674671289741000&source=images&cd=vfe&ved=0CBAQjRxqFwoTCJD6-e7q4PwCFQAAAAAdAAAAABAD'>"
    return bodyEmail;
  }

  regresar(): void {
    this.router.navigateByUrl('/').then(resp => location.reload());
  }


  async SaveLegalPerson() {

    if (this.legalForm.get('email').value != this.legalForm.get('confirmarEmail').value) {
      this.popupAlert.errorAlert(
        `Por favor, revise el formulario de la solicitud, los emails ingresados no son iguales.`,
        4000
      );
      return;
    }

    if (!this.legalForm.valid) {
      this.popupAlert.errorAlert(
        `Por favor, revise el formulario de la solicitud, hay datos invalidos y/o incompletos.`,
        4000
      );

      this.legalForm.markAllAsTouched();
      return;
    }

    this.sending = true;

    this.popupAlert.infoAlert(
      `<b>Registrando usuario...</b> Puede tardar un poco, no actualice o recarge la página, un momento por favor`,
      10000
    );

    const formData = this.legalForm.value;
    const oidToken = this.authService.getLoggedUser().oid;
    let requestToSave = {...formData};

    let idCodeVentanilla: any;
    let personaRegistrada: any;

    this.registrationService.saveLegalPerson(requestToSave).pipe(
      switchMap(resp1 => {
        idCodeVentanilla = resp1.data;
        return this.registrationService.getInfoUserByIdCodeVentanilla(idCodeVentanilla)
      }),
      switchMap(resp2 => {
        personaRegistrada = resp2.data;
        let dataPersonaAddUser = {
          "oid": oidToken,
          "email": personaRegistrada.email
        }
        return this.registrationService.addUserToSecurityAPI(dataPersonaAddUser)
      }),
      switchMap(resp3 => {
        let dataPersonaUpdateUser = {
          "oid": oidToken,
          "email": personaRegistrada.email,
          "nombreCompleto": personaRegistrada.fullName,
          "created": new Date(Date.now()),
          "idPersonaVentanilla": idCodeVentanilla,
          "isEnabled": true
        }
        return this.registrationService.updateUser(dataPersonaUpdateUser)
      }),
      switchMap(resp4 => {
        let bodyEmail = this.cuerpoEmail(personaRegistrada.fullname, personaRegistrada.numeroIdentificacion);

        let cuerpoEmail = {
          "to": personaRegistrada.email,
          "subject": "Activación cuenta Ventanilla Única de Trámites y Servicios Secretaría Distrital de Salud",
          "body": bodyEmail
        }
        return this.registrationService.sendEmail(cuerpoEmail)
      }),
      catchError(error => {
        this.sending = false;
        this.popupAlert.errorAlert('Ocurrió un error al registrarse.', 4000);
        return throwError(() => new Error(error.message));
      })
    ).subscribe({
      next: resp5 => {
        this.popupAlert.successAlert('¡Su registro se ha realizado satisfactoriamente!', 4000);
        Swal.fire({
          icon: 'success',
          title: 'Registro existoso',
          confirmButtonColor: '#0000FF',
          allowEscapeKey: false,
          allowOutsideClick: false,
          confirmButtonText: 'OK',
          text: 'Será redigirido a la página principal y deberá iniciar sesión nuevamente para acceder a los servicios.',
        }).then((result) => {
          this.msalAuthService.logoutPopup({
            mainWindowRedirectUri: "/"
          }).subscribe(resp => {
            this.popupAlert.infoAlert("¡Sesión cerrada exitosamente!", 4000);
            localStorage.clear();
            this.authService.setCurrentUser(null);
          });
        });
      },
      error: err => {
        this.sending = false;
        this.popupAlert.errorAlert('Ocurrió un error al registrarse.', 4000);
      }
    });
  }

  getErrorMessage(field: string): string {
    let message;
    const onlyNumbers: Array<string> = ['telefonoFijo', 'telefonoCelular','numeroDocumentoRepresentanteLegal'];
    const required: Array<string> = ['checkBoxDatosPersonales'
    ];
    if (this.isTouchedField(this.legalForm, field))
    {
      if (this.legalForm?.get(field).hasError('requiredtrue') || required.includes(field)) {
        message = 'Debe marcar la casilla';
      }
      else if (this.legalForm?.get(field).hasError('required')) {
        message = 'Es requerido';
      }
      else if (onlyNumbers.includes(field))
      {
        if (this.legalForm?.get(field).hasError('pattern')) {
          message = `Solo se admiten números`;
        }
        else if (this.legalForm?.get(field).hasError('minlength')) {
          message = `Debe tener al menos (`+this.legalForm?.get(field).errors.minlength.requiredLength+`) caracteres`;
        } else if (this.legalForm?.get(field). hasError('maxlength')) {
          message = `Permite hasta (`+this.legalForm?.get(field).errors.maxlength.requiredLength+`) caracteres`;
        }
      }
      else if (this.legalForm?.get(field).hasError('email')) {
        message = 'No tiene el formato de un email';
      }
    };

    return message;
  }

}
